export const esData = `
  <div class="paragraph">
    <div class="title">TÉRMINOS Y CONDICIONES</div>
    <div class="text-box">
      <div class="text">
        <br><br>
        Este servicio de recompra o “Trade-In” (en adelante, el “Servicio”) es ofrecido por
        Danghuan Europe S.L., sociedad constituida conforme a la legislación española, con
        domicilio en Madrid, España (28045) y NIF B19961911 (en adelante, “Danghuan”),
        correo electrónico legal@danghuan.eu. Las entidades OPPO, Reflection Investment B.V.
        (para España y Francia) y Unumplus Limited (para el Reino Unido), promocionan la
        disponibilidad de este Servicio en sus sitios web oficiales. No obstante, OPPO no
        gestiona, administra ni procesa directamente ninguna parte del programa de recompra.
        <br><br>
        El presente documento regula los términos y condiciones bajo los cuales los
        consumidores residentes en la Unión Europea pueden participar en el programa oficial
        de recompra vinculado a la compra de determinados teléfonos inteligentes.El programa
        se desarrolla en cumplimiento íntegro de la normativa de la Unión Europea, en particular
        de la Directiva 2011/83/UE sobre los derechos de los consumidores y del Reglamento
        (UE) 2016/679 (Reglamento General de Protección de Datos – RGPD).
        <br><br>
        Para los consumidores residentes en el Reino Unido, el programa de recompra se rige
        conforme a la legislación aplicable en dicho país, incluida la Consumer Rights Act 2015
        y el UK General Data Protection Regulation (UK GDPR), incorporado al derecho interno
        mediante la Data Protection Act 2018.
        <br><br>
        ARTÍCULO 1 – ÁMBITO TERRITORIAL Y PRODUCTOS
        <br><br>
        1.1 El Servicio está disponible para personas físicas mayores de 18 años que residan legalmente en cualquier Estado miembro de la Unión Europea (no está disponible en Islas Canarias ni Baleares de españa) o en el Reino Unido.
        <br><br>
        1.2 Los clientes deben actuar a título personal (no profesional) y reunir la condición de
        “consumidor” conforme a la Directiva 2011/83/UE (residentes en la UE) o a la Consumer
        Rights Act 2015 (residentes en el Reino Unido).
        <br><br>
        1.3 Solo se admite un (1) dispositivo usado por cada transacción que cumpla los
        requisitos.
        <br><br>
        1.4 El Servicio se ofrece exclusivamente a clientes que adquieran productos OPPO
        elegibles (“Producto”) a través de las tiendas en línea oficiales de OPPO en Francia,
        España o el Reino Unido, durante el período de campaña correspondiente. Solo
        determinados modelos OPPO podrán acogerse al programa.
        <br><br>
        1.5 El dispositivo entregado debe figurar entre los modelos admitidos publicados en el
        sitio web oficial y cumplir los criterios de funcionalidad y titularidad detallados en el
        Artículo 5.
        <br><br>
        1.6 El cliente podrá entregar un único (1) dispositivo usado por cada Producto adquirido.
        <br><br>
        ARTÍCULO 2 – CONDICIONES CONTRACTUALES
        <br><br>
        2.1 El Servicio opera de manera independiente a la compra de cualquier Producto y no
        constituye una oferta combinada o vinculada con ningún fabricante, distribuidor o
        minorista.
        <br><br>
        2.2 Toda la responsabilidad operativa del Servicio — incluyendo la comunicación con el
        cliente, la logística, la tasación, los pagos y el tratamiento de datos personales — recae
        exclusivamente en Danghuan Europe S.L.
        <br><br>
        2.3 Nada de lo dispuesto en estos Términos limita ni menoscaba los derechos legales
        del consumidor reconocidos por la legislación aplicable, incluyendo, entre otros, la
        Directiva 2011/83/UE y la Consumer Rights Act 2015.
        <br><br>
        2.4 Danghuan se reserva el derecho de rechazar cualquier solicitud de recompra cuando
        existan indicios de fraude, abuso o incumplimiento de las presentes condiciones,
        incluyendo los casos en que la solicitud sea presentada por un tercero en nombre de
        otro usuario.
        <br><br>
        ARTÍCULO 3 – PROCESO DE PARTICIPACIÓN
        <br><br>
        3.1 Los clientes pueden inscribirse en el Servicio de recompra durante el proceso de
        compra en la tienda en línea de OPPO.
        <br><br>
        3.2 Para continuar, deberán completar un cuestionario de autoevaluación e introducir
        los datos del dispositivo (IMEI, modelo y estado).
        <br><br>
        • Por favor, asegúrese de que el modelo de su dispositivo antiguo esté seleccionado
        correctamente. Si es necesario realizar algún cambio, póngase en contacto con
        nosotros lo antes posible en oppo@danghuan.eu para que podamos actualizar la
        información del dispositivo.
        <br><br>
        3.3 En el momento del registro deberán facilitar datos bancarios válidos para el abono
        del pago:
        <br><br>
        • Residentes en la UE/Espacio Económico Europeo: cuenta IBAN compatible SEPA.
        <br><br>
        • Residentes en el Reino Unido: cuenta bancaria en GBP con Sort Code y Account
        Number, apta para pagos Faster Payments o BACS.
        <br><br>
        3.4 El cliente recibirá un correo electrónico con las instrucciones de envío en un plazo
        de 24 horas tras marcarse el nuevo dispositivo como entregado en el sistema logístico.
        <br><br>
        3.5 El dispositivo usado deberá enviarse dentro de los 10 días naturales siguientes a la
        entrega del nuevo producto, y el envío deberá contar con un número de seguimiento
        válido dentro de ese plazo.
        <br><br>
        3.6 El incumplimiento de estos pasos en el plazo establecido provocará la cancelación
        automática de la solicitud.
        <br><br>
        3.7 Las solicitudes incompletas o con datos inconsistentes (por ejemplo, IMEI no
        coincidente o documentación faltante) podrán ser rechazadas sin compensación.
        <br><br>
        3.8. El dispositivo debe embalarse de forma segura conforme a las instrucciones
        facilitadas. El envío es prepagado por Danghuan. En caso de pérdida o daño durante el
        transporte, el cliente deberá contactar con OPPO@danghuan.eu. en un plazo de 15 días
        naturales desde la última actualización de seguimiento. Danghuan facilitará el acceso al
        canal oficial de reclamaciones de UPS y asistirá al cliente en el proceso. Las
        reclamaciones logísticas deberán presentarse dentro de los 60 días siguientes a la
        creaciónde la etiqueta de envío.
        <br><br>
        Cualquier compensación aprobada se abonará directamente a la cuenta IBAN indicada.
        Danghuan no asume responsabilidad adicional en estos casos.
        <br><br>
        3.9. Los dispositivos enviados sin la declaración de integridad o sin la confirmación de
        venta firmada no serán procesados. El cliente será notificado por correo electrónico y
        podrá solicitar su devolución en un plazo de 10 días naturales desde la notificación. Los
        costes de devolución se aplicarán según el Artículo 6.3. Si no se recibe solicitud en dicho
        plazo, Danghuan podrá reciclar o eliminar el dispositivo de manera responsable sin más
        obligación.
        <br><br>
        3.10. Los productos admitidos para recompra incluyen smartphones, relojes inteligentes,
        auriculares inalámbricos y tabletas, conforme a la lista publicada en el sitio web oficial
        de OPPO en el momento de la participación.
        <br><br>
        ARTÍCULO 4 – CONDICIONES DE ACEPTACIÓN DE DISPOSITIVOS
        <br><br>
        4.1 Solo se aceptarán los dispositivos incluidos en la lista de modelos elegibles
        publicada en la web de OPPO.
        <br><br>
        4.2 Todos los dispositivos deberán cumplir los estándares de tasación y estado estético
        definidos por Danghuan. Serán clasificados en Grado A, B o C según las herramientas
        de inspección certificadas y el estado físico, conforme al Artículo 6.
        <br><br>
        4.3. Todos los dispositivos deberán cumplir los siguientes requisitos mínimos de
        funcionamiento y estado, según su categoría:
        <br><br>
        – Smartphones y tabletas: deberán encenderse correctamente, contar con pantalla táctil
        y batería operativas, no presentar daños graves (por ejemplo, pantalla rota o corrosión)
        y estar completamente restablecidos a los ajustes de fábrica, con todas las funciones
        de bloqueo desactivadas (PIN, Apple iCloud, Google FRP, Samsung o Xiaomi).
        <br><br>
        – Relojes inteligentes: deberán poder encenderse, estar libres de bloqueos de cuenta
        (iCloud, Google, Samsung) y funcionar adecuadamente sin daños físicos severos.
        <br><br>
        – Auriculares inalámbricos: deberán incluir ambos auriculares y la base de carga,
        permitir su carga y emparejamiento, y no mostrar signos de daño por agua ni grietas
        estructurales.
        <br><br>
        4.4. Los dispositivos deben ser propiedad exclusiva del cliente y no estar sujetos a
        leasing, financiación o derechos de terceros. Los dispositivos denunciados como
        perdidos, robados, falsificados o manipulados (p. ej. IMEI alterado) serán rechazados
        sin pago alguno.
        <br><br>
        4.5. Los dispositivos que no cumplan los criterios mínimos podrán devolverse si el cliente
        lo solicita dentro de los 7 días naturales siguientes a la notificación (enviada por correo
        electrónico). En caso contrario, se reciclarán de forma responsable.
        <br><br>
        La devolución se regirá por las mismas condiciones y costes establecidos en el
        Artículo 6.3.
        <br><br>
        ARTÍCULO 5 – PLAZOS LOGÍSTICOS Y OBLIGACIONES
        <br><br>
        5.1 El cliente deberá enviar su dispositivo usado en un plazo máximo de 10 días
        naturales desde la recepción del nuevo dispositivo OPPO.
        <br><br>
        5.2 Danghuan enviará recordatorios automáticos al cliente en los días 3 (D+3), 6 (D+6)
        y 9 (D+9) tras la entrega.
        <br><br>
        5.3 Todos los envíos deberán realizarse utilizando la etiqueta de envío prepagada
        facilitada por Danghuan Europe S.L.
        <br><br>
        5.4 Si la etiqueta no es escaneada por el transportista antes del día 15 (D+14), la
        solicitud de recompra se cancelará automáticamente.
        <br><br>
        5.5 El cliente deberá embalar el dispositivo de forma segura para evitar daños durante
        el transporte. Danghuan proporcionará instrucciones de embalaje, pero no materiales
        físicos.
        <br><br>
        5.6 Si el dispositivo recibido presenta un IMEI no coincidente o un estado diferente al
        declarado, Danghuan podrá ajustar la valoración o cancelar la operación.
        <br><br>
        6.1 Los dispositivos serán inspeccionados dentro de los 3 días laborables siguientes a
        su recepción en el almacén designado. La inspección incluye una revisión funcional con
        herramientas certificadas y una evaluación visual del estado estético (Grado A, B o C).
        <br><br>
        6.2 Si las condiciones del dispositivo no coinciden con la información proporcionada por
        el cliente, Danghuan Europe S.L. enviará una nueva oferta ajustada por correo
        electrónico, indicando el nuevo grado y su justificación.
        <br><br>
        6.3 El cliente dispondrá de 7 días naturales desde la notificación para aceptar o rechazar
        la nueva valoración, y podrá solicitar la devolución de su dispositivo.
        <br><br>
        • Clientes en España: Danghuan Europe S.L. asumirá los gastos de devolución.
        <br><br>
        • Clientes en otros países: el cliente abonará el coste de transporte hasta un
        máximo de 22 EUR (GBP 19, IVA incluido). La devolución deberá realizarse
        utilizando la etiqueta prepagada oficial facilitada por Danghuan. Las
        instrucciones de pago se facilitarán por correo electrónico o a través de un enlace
        de pago seguro.
        <br><br>
        El cliente podrá abonar los gastos de devolución mediante:
        <br><br>
        • Transferencia SEPA (para clientes de la UE/EER) al IBAN de Danghuan.
        <br><br>
        • Transferencia en GBP (para clientes del Reino Unido) a la cuenta británica de
        Danghuan mediante Faster Payments o BACS.
        <br><br>
        Si el pago no se recibe dentro de los diez (10) días naturales desde el envío de la
        solicitud de pago, Danghuan Europe S.L. podrá considerar la nueva valoración como
        aceptada y proceder al tratamiento del dispositivo conforme a ella.
        <br><br>
        Cualquier reembolso de los gastos de devolución abonados por el cliente se realizará
        mediante transferencia bancaria en un plazo de cinco (5) días laborables tras la
        verificación del pago por parte de Danghuan, utilizando la misma cuenta bancaria
        indicada en el registro de la recompra.
        <br><br>
        6.4. Si el cliente no responde a la nueva valoración dentro de 7 días naturales, el servicio
        de atención al cliente de Danghuan intentará contactar con el cliente directamente. Si
        no se recibe respuesta dentro de 30 días naturales desde la notificación, la nueva
        valoración se considerará rechazada. Además, para los clientes residentes fuera de
        España, se aplicará un coste de devolución. El cliente deberá pagar el importe
        correspondiente a su país dentro de 5 días naturales después de recibir la solicitud de
        pago. Una vez confirmado el pago, Danghuan verificará la transacción dentro de 5 días
        laborables y organizará la devolución al domicilio original proporcionado durante el
        registro de la recompra. El cliente será notificado por correo electrónico una vez que el
        envío haya sido despachado, incluyendo la información de seguimiento correspondiente. El cliente es responsable de supervisar activamente el estado del envío de devolución y de organizar, cuando sea necesario, la recogida o recepción del paquete en tiempo oportuno. Danghuan Europe S.L. notificará al cliente con antelación por correo electrónico el número de seguimiento de la devolución y la información logística pertinente. Si el cliente no recoge o no recibe el paquete dentro del plazo establecido por el proveedor logístico, lo que resulte en la devolución del paquete o en la necesidad de un nuevo envío, todos los costes adicionales de envío o gestión derivados correrán exclusivamente a cargo del cliente. Danghuan Europe S.L. no será responsable de dichos costes ni de las consecuencias que se deriven de ello.
        <br><br>
        6.5. Los dispositivos considerados no elegibles debido a daños irreparables,
        manipulación o ineligibilidad (por ejemplo, bloqueo iCloud, robo o IMEI no coincidente)
        no recibirán valoración. Los clientes dispondrán de 7 días naturales desde la notificación
        para solicitar su devolución; en caso contrario, el dispositivo será reciclado de forma
        responsable.
        <br><br>
        6.6. El pago por los dispositivos aceptados se realizará dentro de 3 días laborables a
        partir de la fecha de aceptación, mediante transferencia SEPA.
        <br><br>
        6.7. Criterios de valoración de dispositivos:
        producto (smartphone, tableta, reloj inteligente, auriculares) está sujeta a requisitos
        específicos:
        <br><br>
        I. Smartphones y tabletas
        <br><br>
        Grado A – Excelente estado
        <br><br>
        • El dispositivo presenta signos normales de uso pero se encuentra en buen
        estado.
        <br><br>
        • Sin grietas, abolladuras ni pérdida de pintura.
        <br><br>
        • Todas las funciones (pantalla, táctil, cámara, botones, altavoz, batería,
        conectividad, etc.) operan normalmente.
        <br><br>
        • Para dispositivos Apple, salud de batería ≥ 90 %.
        <br><br>
        Grado B – Ligeros signos de uso
        <br><br>
        • El dispositivo muestra signos leves de uso pero se encuentra en buen estado.
        <br><br>
        • Puede tener 2–3 arañazos pequeños o leves marcas; sin daños graves.
        <br><br>
        • Todas las funciones principales (pantalla, táctil, sensores, Bluetooth) operan con
        normalidad.
        <br><br>
        • Para dispositivos Apple, salud de batería ≥ 80 %.
        <br><br>
        Grado C – Signos visibles de uso
        <br><br>
        • El dispositivo presenta signos evidentes de desgaste, como múltiples arañazos,
        pérdida de pintura o una pequeña abolladura
        <br><br>
        • Se permite una pequeña grieta en la pantalla siempre que no afecte a la
        funcionalidad
        <br><br>
        • Todas las funciones principales (pantalla, táctil, cámara, conectividad) siguen
        operativas.
        <br><br>
        Grado D – No recuperable / Rechazado
        <br><br>
        • El dispositivo está gravemente dañado o no se enciende.
        <br><br>
        • Grietas profundas, marco doblado, pantalla o carcasa rota, piezas faltantes, fallo
        de placa base, corrosión, sin respuesta táctil o visual.
        <br><br>
        • El dispositivo no puede conectarse ni probarse (por ejemplo, bloqueado por
        Google / iCloud / PIN).
        <br><br>
        • La batería del dispositivo está hinchada o presenta otros problemas que no
        cumplen los estándares de seguridad, por ejemplo: sobrecalentamiento excesivo
        o la carcasa separada por la presión de la batería.
        <br><br>
        II. Smartwatches and Bands
        <br><br>
        Grado A – Excelente estado
        <br><br>
        • El dispositivo presenta signos normales de uso pero se encuentra en buen
        estado.
        <br><br>
        • Sin grietas, pérdida de pintura ni decoloración.
        <br><br>
        • Todas las funciones (táctil, corona, sensores, Bluetooth, Wi-Fi) funcionan
        correctamente.
        <br><br>
        • Para dispositivos Apple, salud de batería ≥ 90 %.
        <br><br>
        Grado Grado B – Ligeros signos de uso
        <br><br>
        • El dispositivo muestra signos leves de uso pero se encuentra en buen estado.
        <br><br>
        • Puede tener 2–3 pequeños arañazos o marcas; sin daños importantes.
        <br><br>
        • Todas las funciones principales (pantalla, táctil, sensores, Bluetooth) funcionan
        correctamente.
        <br><br>
        • Para dispositivos Apple, salud de batería ≥ 80 %.
        <br><br>
        Grado C – Signos visibles de uso
        <br><br>
        • El dispositivo presenta signos visibles de desgaste como múltiples arañazos,
        pérdida de pintura o pequeñas abolladuras.
        <br><br>
        • Algunos sensores o botones pueden tener menor sensibilidad, pero las
        funciones esenciales siguen funcionando.
        <br><br>
        • Duración de batería ligeramente reducida (&lt; 80 %).
        <br><br>
        Grado D – No recuperable / Rechazado
        <br><br>
        • El dispositivo está gravemente dañado o no se enciende.
        <br><br>
        • Pantalla rota, botones o corona defectuosos, fallo de placa base, bloqueo de
        cuenta (iCloud / Google / PIN) o corrosión.
        <br><br>
        • No elegible para recompra.
        <br><br>
        Auriculares inalámbricos
        <br><br>
        Grado A – Excelente estado
        <br><br>
        • El dispositivo está en excelente estado, limpio y sin arañazos ni manchas.
        <br><br>
        • Todas las funciones (sonido, táctil, micrófono, Bluetooth, carga) operan
        correctamente.
        <br><br>
        • El estuche de carga está intacto y funcional.
        <br><br>
        Grado Grado B – Ligeros signos de uso
        <br><br>
        • El dispositivo presenta signos leves de uso, como marcas superficiales o ligeros
        roces, pero se encuentra en buen estado.
        <br><br>
        • La calidad del sonido es normal, Bluetooth estable y el estuche de carga puede
        tener pequeñas marcas.
        <br><br>
        • Las funciones táctiles y de micrófono operan correctamente.
        <br><br>
        Grado C – Signos visibles de uso
        <br><br>
        • El dispositivo muestra desgaste visible, como arañazos múltiples, decoloración
        o pequeñas abolladuras.
        <br><br>
        • El sonido o el micrófono pueden estar ligeramente degradados, pero siguen
        siendo funcionales.
        <br><br>
        • El Bluetooth puede ser menos estable; el estuche de carga presenta arañazos o
        daños leves.
        <br><br>
        Grado D – No recuperable / Rechazado
        <br><br>
        • El dispositivo está incompleto, no se enciende o falla en funciones básicas.
        <br><br>
        • Falta un auricular o el estuche, fallo de batería, puerto de carga roto, sin
        emparejamiento Bluetooth o daño por agua.
        <br><br>
        • No elegible para recompra.
        <br><br>
        6.8. Si el dispositivo recibido no coincide con el modelo o número de serie declarado por
        el cliente, Danghuan contactará con el cliente para informarle de la nueva oferta. Si el
        dispositivo recibido es elegible para el programa de recompra, se emitirá una nueva
        valoración basada en su estado real.
        <br><br>
        El cliente deberá revisar y aceptar la nueva valoración y firmar una nueva Declaración
        de Propiedad e Integridad correspondiente al dispositivo recibido antes de continuar con
        el proceso.
        <br><br>
        Si el cliente no acepta la nueva oferta en un plazo de 7 días naturales, podrá solicitar la
        devolución del dispositivo conforme a las condiciones descritas en el Artículo 6.3.
        <br><br>
        6.9. El proceso de recompra requiere que el cliente firme y envíe la Declaración de
        Propiedad e Integridad del dispositivo. La falta de envío o firma de este documento
        puede derivar en el rechazo de la solicitud. En tal caso, el dispositivo podrá devolverse
        al cliente a petición suya según el Artículo 6.3 o reciclarse de forma responsable si no
        se recibe respuesta en el plazo correspondiente.
        <br><br>
        6.10. La cotización inicial de recompra proporcionada al cliente es indicativa y está sujeta a verificación. Aunque el valor cotizado puede mantenerse durante un período limitado tras la entrega del nuevo dispositivo, Danghuan Europe S.L. se reserva el derecho de revisar y ajustar dicha cotización en función de factores que incluyen, entre otros, el estado del dispositivo, las fluctuaciones del mercado y los plazos de procesamiento.
        Debido a la naturaleza del mercado de dispositivos electrónicos, el valor de los dispositivos puede depreciarse con el tiempo. Como referencia general, los precios pueden disminuir de forma progresiva semanalmente, normalmente en torno a un 6%, aunque los ajustes reales pueden variar en función de las condiciones del mercado y de las categorías de productos.
        En los casos en que el proceso de recompra no se complete dentro de un plazo razonable o cuando las condiciones del mercado cambien significativamente, el valor cotizado originalmente podrá dejar de ser aplicable.
        <br><br>
        ARTÍCULO 7 – CONDICIONES DE PAGO
        <br><br>
        7.1. Los pagos se efectuarán exclusivamente mediante transferencia bancaria a una
        cuenta a nombre del cliente, tal como se haya indicado durante el registro del proceso
        de recompra.
        <br><br>
        7.2. Para los clientes residentes en la Unión Europea o en el Espacio Económico
        Europeo, el pago se realizará mediante transferencia SEPA a un IBAN emitido por una
        entidad financiera válida dentro de la zona SEPA.
        <br><br>
        7.3. Para los clientes residentes en el Reino Unido, el pago podrá realizarse en GBP
        mediante transferencia Faster Payments o BACS a una cuenta bancaria del Reino Unido
        que figure a nombre del cliente y cuyos datos sean válidos y completos.
        <br><br>
        7.4. Las tarjetas prepago, las cuentas virtuales o los datos bancarios que no coincidan
        con el nombre registrado del cliente provocarán el fracaso del pago y podrán derivar en
        la cancelación de la transacción de recompra.
        <br><br>
        7.5. Danghuan Europe S.L. no será responsable de los retrasos o errores causados por
        datos bancarios incompletos, incorrectos o caducados.
        <br><br>
        7.6. Si el cliente proporciona datos bancarios incorrectos, no válidos o que no coinciden,
        y el pago se procesa correctamente a la cuenta facilitada, Danghuan Europe S.L. no
        asumirá responsabilidad por ninguna pérdida resultante. El cliente reconoce su total
        responsabilidad de garantizar la exactitud de su información bancaria. En tales casos
        no se efectuará un segundo pago.
        <br><br>
        7.7. Una vez completado el proceso de recompra, si el importe reembolsable
        especificado en el pedido es inferior al importe del bono de recompra aplicable, solo se
        abonará la cantidad residual reembolsable.
        <br><br>
        7.8. El bono de recompra — si lo hubiere — se cancelará en caso de reembolso del
        pedido del Producto.
        <br><br>
        7.9. Todas las comisiones o gastos bancarios relacionados con los pagos de recompra
        correrán a cargo de Danghuan Europe S.L.
        <br><br>
        7.10. El importe total a abonar al cliente podrá constar de dos transferencias separadas:
        (a) el valor del dispositivo entregado, pagado directamente por Danghuan; y
        (b) cualquier bono promocional aplicable otorgado por OPPO, pagado por OPPO por
        separado a los mismos datos bancarios proporcionados por el cliente.
        <br><br>
        Ambos pagos podrán recibirse en momentos distintos, según los plazos de
        procesamiento de cada parte.
        <br><br>
        ARTÍCULO 8 – RESPONSABILIDAD Y RIESGO DE PÉRDIDA
        <br><br>
        8.1. Los clientes deberán utilizar la etiqueta de envío prepagada y el transportista
        designado por Danghuan Europe S.L. Cualquier método de envío alternativo anulará la
        cobertura de responsabilidad.
        <br><br>
        8.2. Un dispositivo se considerará perdido si no se rastrea, confirma o recibe por
        Danghuan Europe S.L. dentro de los 15 días naturales desde la fecha de entrega al
        transportista.
        <br><br>
        • Para los envíos realizados con UPS, las reclamaciones deberán presentarse
        dentro de los 60 días posteriores a la creación de la etiqueta de envío.
        <br><br>
        • Para los envíos realizados con CORREOS dentro de España, las reclamaciones
        deberán presentarse lo antes posible, preferiblemente dentro de los 15 días
        posteriores al envío y, en todo caso, no más tarde de 1 año desde la fecha de
        envío.
        <br><br>
        Danghuan asistirá a los clientes en el proceso de reclamación ante el servicio de
        mensajería, el cual generalmente tarda entre 30 y 60 días.
        <br><br>
        8.3. Este marco de responsabilidad se aplica por igual tanto a los envíos desde el cliente
        hacia Danghuan Europe S.L. como a los envíos de devolución desde Danghuan Europe
        S.L. hacia el cliente.
        <br><br>
        8.4. Si se confirma la pérdida de un envío bajo el sistema logístico de Danghuan,
        Danghuan Europe S.L. ayudará al cliente a presentar una reclamación formal ante el
        servicio de mensajería correspondiente.
        <br><br>
        8.5. La responsabilidad y la compensación se limitan estrictamente a los casos en los
        que el cliente haya utilizado la etiqueta de envío autorizada proporcionada por
        Danghuan Europe S.L., y el evento de envío pueda verificarse.
        <br><br>
        8.6. En tales casos de pérdida confirmada, la compensación no excederá el valor final
        de tasación del dispositivo, determinado antes de la confirmación de la pérdida.
        <br><br>
        ARTÍCULO 9 – DATOS PERSONALES Y CUMPLIMIENTO DEL RGPD
        <br><br>
        9.1. Todos los datos personales proporcionados por los clientes durante su participación
        en el Programa de Recompra serán tratados de conformidad con la legislación aplicable
        en materia de protección de datos, incluyendo el Reglamento (UE) 2016/679
        (Reglamento General de Protección de Datos – RGPD) para los residentes en la Unión
        Europe, así como el UK General Data Protection Regulation (UK GDPR) y la Data
        Protection Act 2018 para los residentes en el Reino Unido.
        <br><br>
        Danghuan Europe S.L. actúa como responsable del tratamiento y adopta las medidas
        técnicas y organizativas adecuadas para garantizar la confidencialidad, integridad y
        seguridad de todos los datos personales procesados en el marco del Programa de
        Recompra.
        <br><br>
        9.2. Los datos recopilados incluyen, entre otros: nombre, apellidos, dirección de correo
        electrónico, dirección postal, número de teléfono, cuenta bancaria, documentos de
        identidad, IMEI del dispositivo entregado y respuestas proporcionadas en el formulario
        de evaluación.
        <br><br>
        9.3. Los datos serán utilizados únicamente para los siguientes fines: verificación de
        identidad, gestión y evaluación de la solicitud de recompra, organización de la recogida
        y el envío del dispositivo, atención al cliente, contabilidad y ejecución de los pagos. Los
        datos personales no se utilizarán con fines comerciales ni se compartirán con terceros
        sin consentimiento expreso, salvo en los casos en que exista una obligación legal.
        <br><br>
        9.4. Los datos se conservarán únicamente durante el tiempo necesario para completar
        la transacción de recompra y cumplir con las obligaciones legales aplicables. A menos
        que la ley disponga lo contrario, todos los datos del cliente se eliminarán dentro de los
        30 días naturales posteriores a la finalización del proceso de recompra y el pago
        correspondiente. No obstante, ciertos datos podrán conservarse hasta un máximo de 90
        días cuando sea necesario para auditorías, conciliaciones de pago, investigaciones de
        <br><br>
        fraude o revisiones por parte de socios de marca, conforme a la normativa de protección
        de datos.
        <br><br>
        9.5. El cliente es el único responsable de eliminar de forma segura toda la información
        personal de su dispositivo antes de enviarlo. Esto incluye contactos, mensajes,
        fotografías, aplicaciones, correos electrónicos, historiales de navegación, cuentas y
        cualquier otro contenido confidencial.
        <br><br>
        9.6. El cliente también deberá retirar cualquier tarjeta SIM o microSD y desactivar todas
        las funciones de seguridad, tales como bloqueos de pantalla, contraseñas y cuentas
        vinculadas (por ejemplo, Apple iCloud, Google o Samsung Find My Mobile). El
        incumplimiento de esta obligación puede dar lugar a que el dispositivo sea considerado
        no elegible para la recompra.
        <br><br>
        9.7. Información adicional sobre el tratamiento de datos personales y los derechos de
        los clientes (acceso, rectificación, supresión, limitación u oposición) está disponible en
        la Política de Privacidad publicada en el sitio web oficial de Danghuan Europe S.L.
        <br><br>
        ARTÍCULO 10 – FRAUD AND NON-COMPLIANCE POLICY
        <br><br>
        10.1. Las solicitudes que contengan declaraciones falsas o que incluyan dispositivos
        listados como robados, arrendados, manipulados o que no sean propiedad del
        solicitante serán descalificadas sin derecho a compensación alguna.
        <br><br>
        10.2. Danghuan Europe S.L. se reserva el derecho de excluir a dichos participantes de
        cualquier programa de recompra actual o futuro.
        <br><br>
        10.3. En los casos en que se detecte fraude, suplantación de identidad o intentos de
        eludir los criterios de elegibilidad con fines comerciales, podrán iniciarse acciones
        legales pertinentes.
        <br><br>
        ARTÍCULO 11 – FUERZA MAYOR
        <br><br>
        11.1. En caso de catástrofes naturales, restricciones gubernamentales, pandemias,
        conflictos laborales o interrupciones en el transporte que se encuentren fuera del
        control razonable de Danghuan Europe S.L., dicha entidad podrá suspender
        temporalmente el servicio de recompra sin que ello genere responsabilidad alguna por
        daños o perjuicios.
        <br><br>
        11.2. Cualquier retraso o incumplimiento derivado de tales circunstancias de fuerza
        mayor no se considerará un incumplimiento contractual.
        <br><br>
        ARTÍCULO 12 – LEY APLICABLE Y JURISDICCIÓN COMPETENTE
        <br><br>
        12.1. Los presentes Términos y Condiciones se regirán e interpretarán de conformidad
        con la legislación de España. Nada de lo establecido en este documento afectará a los
        derechos de protección del consumidor reconocidos por la legislación del país de
        residencia del cliente.
        <br><br>
        12.2. Cualquier controversia que surja de, o esté relacionada con, los presentes
        Términos y Condiciones estará sujeta a la jurisdicción exclusiva de los tribunales de
        <br><br>
        Madrid, España, sin perjuicio del derecho del consumidor a ejercer sus acciones ante
        los tribunales de su lugar de residencia.
      </div>
    </div>
  </div>
`;
